<script setup lang="ts">
import TimelineScorecard from '../TimelineScorecard.vue'
import { Timesheets } from '../../types/timers'
import { computed, ref } from 'vue'
import BaseModal from '../wrappers/BaseModal.vue'
import FilteringDataDisplay from '../FilteringDataDisplay.vue'
import { formatTravelActivitesForTable } from '../../store/timers'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { useUserStore } from '../../store/useUserStore'
const props = defineProps<{
  timesheets: Timesheets
}>()

const totalDistance = computed(() => {
  return props.timesheets.reduce((acc, timesheet) => {
    return acc + timesheet.toBePaidDistance
  }, 0)
})

const travelActivities = computed(() => {
  const data = props.timesheets.flatMap((timesheet) => timesheet.timers)
  return formatTravelActivitesForTable(data)
})

const { t } = useI18n({ useScope: 'global' })
const timelineLabel = (key: string) => t(`timeline.${key}`)
const payPeriod = (key: string) => t(`payPeriod.${key}`)
const user = storeToRefs(useUserStore())
const headerText = computed(() => {
  return `${payPeriod('toBePaid')} ${timelineLabel(user.distance.value)}`
})

const value = ref(false)
//todo change distance
</script>
<template>
  <TimelineScorecard @click="value = true" :header="headerText" :subheader="totalDistance" />
  <BaseModal v-model="value">
    <template #title>{{
      `${t('form.total')} ${timelineLabel(user.distance.value)}: ${totalDistance}`
    }}</template>
    <template #content>
      <FilteringDataDisplay :table-data="travelActivities" :enable-filters="false" />
    </template>
    <template #actions>
      <q-btn rounded flat :label="t('form.close')" v-close-popup />
    </template>
  </BaseModal>
</template>
